import { useEffect } from "react";
import { getRedirectResult } from "firebase/auth";
import './authenticatio.style.scss'


import { async } from "@firebase/util";
import { Await } from "react-router-dom";

import SignUpForm from "../../components/sign-up/sign-up-form/sign-up-form.componenet";
import SignInForm from "../../components/sign-in-form/sign-up-form/sign-in-form.componenet";


const Authentication=()=>{ 
    return (
        <div className="authentication-container">
            
            <SignInForm />
            <SignUpForm />
            
            
        </div>
    )

};
export default Authentication